<app-jumbotron
  class="flex flex-row lt-md:flex-col gap-[16px] justify-between items-center lt-md:justify-start lt-md:items-start"
>
  <div class="flex flex-col gap-[4px]" #widthIndicator>
    <vi-text>{{ '+INSTALLATIONS.INSTALLATION.VICARE_THERMOSTAT.SUBTITLE' | translate }}</vi-text>
  </div>
  <div>
    <button
      mat-raised-button
      color="primary"
      gtm="onOpen"
      gtmAction="Add device dialog"
      gtmCategory="commissioning"
      [matBounceButton]="widthIndicator"
      (click)="onAddComponent()"
    >
      {{ '+INSTALLATIONS.INSTALLATION.VICARE_THERMOSTAT.ADD_COMPONENT_BUTTON' | translate }}
    </button>
  </div>
</app-jumbotron>

<div class="wrapper">
  <app-feature-list-container *ngIf="gatewayStore.climateSensorDevice$ | async as climateSensor">
    <ng-container
      [ngTemplateOutlet]="deviceFeatureDetails"
      [ngTemplateOutletContext]="{ $implicit: climateSensor }"
    ></ng-container>
  </app-feature-list-container>
  <ng-container *ngIf="gatewayStore.repeaterDevices$ | async as repeaters">
    <app-feature-list-container *ngFor="let repeater of repeaters">
      <ng-container
        [ngTemplateOutlet]="deviceFeatureDetails"
        [ngTemplateOutletContext]="{ $implicit: repeater }"
      ></ng-container>
    </app-feature-list-container>
  </ng-container>
  <ng-container *ngIf="remoteControllers.length" [ngTemplateOutlet]="remoteDevices"> </ng-container>
</div>

<ng-template #deviceFeatureDetails let-device>
  <div class="title-section">
    <h3>
      {{ gatewayStore.getDeviceRoles(device.id) | async | translateDeviceByRoles }}
    </h3>
    <button
      mat-icon-button
      gtm="onOpen"
      gtmAction="Delete device dialog"
      gtmCategory="commissioning"
      [viConfirm]="{
        title: '+INSTALLATIONS.INSTALLATION.VICARE_THERMOSTAT.DELETE_COMPONENT.TITLE' | translate,
        content: '',
        cancelBtn: 'GENERAL.BUTTON.NO' | translate,
        confirmBtn: 'GENERAL.BUTTON.YES' | translate
      }"
      (confirm)="deleteDevice(device)"
      (cancel)="onDeleteComponentCancel()"
    >
      <mat-icon iconPositionEnd>close</mat-icon>
    </button>
  </div>
  <app-cs-panel content [deviceId]="device.id"></app-cs-panel>
</ng-template>

<ng-template #remoteDevices>
  <ng-container *ngFor="let device of remoteControllers">
    <app-remote-controller-overlay
      [device]="device"
      (confirmDelete)="deleteVitotrol($event)"
      [showTitleAndAction]="true"
    ></app-remote-controller-overlay>
  </ng-container>
</ng-template>
